import type { Config } from '../utils';

import { createContext } from 'react';

export const ConfigContext = createContext<Config | null>(null);

export const ConfigProvider = ({ config, children }: { config: Config; children: React.ReactNode }) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};
